import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { Button, Card, Divider, Space } from "antd"
import { PlusOutlined, ReloadOutlined, TrophyOutlined } from "@ant-design/icons"
import type React from "react"
import LevelTable from "./components/LevelTable"
import LevelModal from "./components/LevelModal"
import { levelService, type LevelItem } from "@/services/gamification/levelApi"

export const LevelPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingLevel, setEditingLevel] = useState<LevelItem | null>(null)

  const {
    data: result,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["level_list"],
    queryFn: () => levelService.list(),
  })

  const levels: LevelItem[] = result?.data || []

  const handleOpenCreateModal = () => {
    setEditingLevel(null)
    setIsModalOpen(true)
  }

  const handleOpenEditModal = (record: LevelItem) => {
    setEditingLevel(record)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingLevel(null)
  }

  return (
    <div className="flex flex-col gap-2">
      <Card
        className="flex min-h-0 grow flex-col shadow-xs"
        classNames={{ body: "flex grow flex-col" }}
        title={
          <div className="flex items-center justify-between py-1">
            <div className="flex items-center gap-2">
              <TrophyOutlined className="text-amber-500 text-lg" />
              <span className="font-semibold text-base text-gray-800">Quản lý Cấp độ (Levels)</span>
              <Divider orientation="vertical" />
              <span className="font-normal text-gray-500 text-sm">
                Tổng cộng: <strong className="text-gray-700">{levels.length}</strong> mốc cấp độ
              </span>
            </div>
            <Space>
              <Button icon={<ReloadOutlined spin={isFetching} />} onClick={() => refetch()} loading={isFetching}>
                Làm mới
              </Button>
              <Button type="primary" icon={<PlusOutlined />} onClick={handleOpenCreateModal}>
                Thêm cấp độ
              </Button>
            </Space>
          </div>
        }
      >
        <LevelTable data={levels} loading={isFetching} onEdit={handleOpenEditModal} />
      </Card>

      <LevelModal
        open={isModalOpen}
        initialData={editingLevel}
        onClose={handleCloseModal}
        onSuccess={() => refetch()}
      />
    </div>
  )
}

export default LevelPage
